import * as types from './types';

// consulta en el backend cual fue el ultimo paso cargado con exito
const getPostingLastStep = idPost => ({
  type: types.GET_POSTING_LAST_STEP,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/posting/progress/${idPost}`,
    method: 'GET'
  }
});

// hace el update local del ultimo paso cuando se termina de cargar un modulo
const updateLastStep = step => ({
  type: types.UPDATE_LAST_STEP,
  payload: {
    step
  }
});

const setCurrentStep = value => ({
  type: types.SET_CURRENT_STEP,
  payload: value
});

const setPreventTransition = value => ({
  type: types.SET_PREVENT_TRANSITION,
  payload: value
});

const setNextStepperRoute = value => ({
  type: types.SET_NEXT_STEPPER_ROUTE,
  payload: value
});

const setStepperFormRef = value => ({
  type: types.SET_STEPPER_FORM_REF,
  payload: value
});

const setSnackAction = value => ({
  type: types.SET_SNACKBAR,
  payload: value
});

export {
  getPostingLastStep,
  setPreventTransition,
  updateLastStep,
  setCurrentStep,
  setStepperFormRef,
  setNextStepperRoute,
  setSnackAction
};
